export default __webpack_public_path__ + "static/card-share-lwart-013cdd1f13a74f5f2e98760d3986f3b3.png";